// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"00f3c323","48":"93191493","419":"f5a4398b","441":"d69eb8c8","563":"3faf606d","787":"355e5ef8"}[chunkId] + ".chunk.js";
};